module.exports = __webpack_public_path__ + "img/logovertical.546aa928.png";